import _ from "@/boot/lodash";
import store from "@/store";
import { IFilter } from "@/models/tables";
import { FilterOperators, FilterTypes } from "@/data/table";
import i18n from "@/i18n";
import { AccessRoleTypes } from "@/data/enums";
import { DataModules } from "@/store/modules/data/index";
import { NotificationCategoryCodes } from "@/data/enums/notifications";
import { UpmindObjectTypes } from "@/data/enums/objects";
import { serialiseConfig } from "@/helpers/table";

export const HookFilter: (config?: {
  categoryCode?: NotificationCategoryCodes;
  hookCodeLike?: string;
}) => IFilter = (config = {}) => {
  // Filters
  const categoryFilter = config?.categoryCode
    ? { "filter[category.code]": config?.categoryCode }
    : {};

  const hookCodeLike = config?.hookCodeLike
    ? { "filter[code|like]": config.hookCodeLike }
    : {};

  return {
    key: "hook.id",
    label: i18n.t("_.event"),
    type: FilterTypes.SELECT,
    operator: FilterOperators.EQUAL,
    optionsFunc: async () => {
      const hooks = await store.dispatch(
        `data/${DataModules.NOTIFICATIONS_HOOKS}/list`,
        {
          storeData: false,
          params: {
            limit: 0,
            ...categoryFilter,
            ...hookCodeLike
          }
        }
      );

      const { HookLogEventsMap } = await import(
        "@/components/app/global/timelineComponent/events"
      );

      return _.map(hooks, hook => ({
        value: `${hook.id}`,
        label: HookLogEventsMap?.[hook.code]?.name || hook.name
      }));
    }
  };
};

export const AccessRoleFilter: () => IFilter = () => ({
  key: "access_role",
  label: i18n.t("_.actor_type"),
  type: FilterTypes.SELECT_CHECKBOX,
  options: [
    {
      value: AccessRoleTypes.CLIENT,
      label: i18n.t("_.client")
    },
    {
      value: AccessRoleTypes.GUEST,
      label: i18n.t("_.guest")
    },
    {
      value: AccessRoleTypes.USER,
      label: i18n.t("_.staff")
    }
  ],
  value: [AccessRoleTypes.GUEST, AccessRoleTypes.CLIENT],
  operator: FilterOperators.EQUAL
});

export const ObjectTypeFilter: () => IFilter = () => ({
  key: "object_type",
  label: i18n.t("_.type"),
  type: FilterTypes.SELECT_CHECKBOX,
  options: [
    {
      value: UpmindObjectTypes.CLIENT,
      label: i18n.t("_.client")
    },
    {
      value: UpmindObjectTypes.CONTRACT,
      label: i18n.t("_.contract")
    },
    {
      value: UpmindObjectTypes.CONTRACTS_PRODUCT,
      label: i18n.t("_.contracts_product")
    },
    {
      value: UpmindObjectTypes.INVOICE,
      label: i18n.t("_.invoice")
    },
    {
      value: UpmindObjectTypes.BULK_ACTION,
      label: i18n.t("_.bulk_action")
    }
  ],
  value: [],
  operator: FilterOperators.EQUAL
});

export const DateCreatedFilter: () => IFilter = () => ({
  key: "created_at",
  label: i18n.t("_.date_created"),
  type: FilterTypes.DATE,
  operator: FilterOperators.EQUAL
});

export const routeToAdminLogsFromClient = () => ({
  name: "adminActivityLogs",
  query: {
    AAT1: serialiseConfig({
      filters: [
        {
          key: "object_type",
          operator: FilterOperators.EQUAL,
          value: UpmindObjectTypes.CLIENT
        }
      ]
    })
  }
});

export const routeToAdminLogsFromBulkActions = () => ({
  name: "adminActivityLogs",
  query: {
    AAT1: serialiseConfig({
      filters: [
        {
          key: "object_type",
          operator: FilterOperators.EQUAL,
          value: UpmindObjectTypes.BULK_ACTION
        }
      ]
    })
  }
});

export const routeToAdminLogsFromOrders = () => ({
  name: "adminActivityLogs",
  query: {
    AAT1: serialiseConfig({
      filters: [
        {
          key: "object_type",
          operator: FilterOperators.EQUAL,
          value: UpmindObjectTypes.CONTRACT
        }
      ]
    })
  }
});
